export const uploadToS3 = async ({
  url,
  file,
}: {
  url: string;
  file: File;
}) => {
  // Re-wrap the bytes so Blob has no type -> browser won’t send Content-Type
  const buf = await file.arrayBuffer();
  const raw = new Blob([buf]); // <-- no { type } passed

  const res = await fetch(url, {
    method: "PUT",
    body: raw,
    credentials: "omit", // important: no cookies
    // DO NOT pass any headers here
  });

  // S3 can return 200 or 204
  if (res.status !== 200 && res.status !== 204) {
    let detail = "";
    try { detail = await res.text(); } catch {}
    throw new Error(`S3 upload failed: ${res.status} ${res.statusText}${detail ? ` — ${detail}` : ""}`);
  }

  return {
    success: true,
    status: res.status,
    eTag: res.headers.get("ETag") ?? undefined,
    message: "File uploaded successfully",
  };
};